import request from '@/config/axios'

export interface ScenicListConfigOption {
  label: string
  value: string
  badge?: string
}

export interface ScenicListConfigKingkong {
  label: string
  icon: string
  bg?: string
  keyword?: string
}

export interface ScenicListConfigTabbar {
  code: string
  label: string
  path: string
  iconClass: string
  activeIconClass: string
}

export interface ScenicListConfigBanner {
  id?: number
  image: string
  title: string
  jumpType: 'category' | 'keyword' | 'scenic' | 'filter' | 'webview'
  scenicId?: number
  keyword?: string
  category?: string
  freeOnly?: boolean
}

export interface ScenicListConfigVO {
  searchPlaceholder: string
  hotKeywords: string[]
  banners: ScenicListConfigBanner[]
  categories: ScenicListConfigOption[]
  /** 排序 / 距离 / 时长已改由系统字典配置（scenic_sort / scenic_distance / scenic_duration），不再在本页维护 */
  sortOptions?: ScenicListConfigOption[]
  distanceOptions?: ScenicListConfigOption[]
  durationOptions?: ScenicListConfigOption[]
  kingkong: ScenicListConfigKingkong[]
  tabbar: ScenicListConfigTabbar[]
  hotCount: number
}

/**
 * 景区列表页配置（移动端 /scenic/scenic/list-config 同源配置）
 */
export const ScenicListConfigApi = {
  get: () => request.get<ScenicListConfigVO>({ url: '/scenic/list-config/get' }),
  save: (data: ScenicListConfigVO) => request.post<boolean>({ url: '/scenic/list-config/save', data })
}

/** 本周热销预览（最近 7 天已支付订单人数聚合） */
export const getScenicHotSpots = (limit: number) =>
  request.get<Array<Record<string, any>>>({ url: '/scenic/scenic/hot', params: { limit } })
